"use strict";

module.exports = {
    on: function on(name, listener) {
        if (!name || !listener) return;

        this._events_ = this._events_ || {};
        this._events_[name] = this._events_[name] || [];
        this._events_[name].push(listener);
    },
    trigger: function trigger(name) {
        var events = this._events_;
        if (!name || !events || !events[name]) return;

        var queue = events[name];
        var args = [].slice.call(arguments, 1);
        for (var i = 0; i < queue.length; i++) {
            queue[i].apply(this, args);
        }
    }
};